export const FREQUENCY_OPTIONS = [
  { id: '1', name: 'Every Day' },
  { id: '2', name: 'Every Week' },
  { id: '3', name: 'Every Month' },
]
